export const START_LOADING = 'START_LOADING'
export const UPDATE_ATTRIBUTE_SELECTION = 'UPDATE_ATTRIBUTE_SELECTION'
export const SET_INITAL_ATTRIBUTES_SELECTION = 'SET_INTIAL_ATTRIBUTES_SELECTION'
export const UPDATE_ATTRIBUTES_LIST = 'UPDATE_ATTRIBUTES_LIST'
